import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { MenuItem, Select, Typography } from '@mui/material'
import { types } from '../data'
import { useParagraphContext } from './hooks'

const ParagraphTypeSelect = (props) => {
  const { ...rest } = props
  const { t } = useTranslation()
  const { editable, paragraph, saveParagraph } = useParagraphContext()

  const filteredTypes = useMemo(() => {
    return types.filter((type) => !type.endsWith('right'))
    // return types
  }, [])

  return editable ? (
    <Select
      sx={{ p: 0, ...(rest.sx ?? {}) }}
      variant="standard"
      value={paragraph.type.replace(/right$/, 'left')}
      {...rest}
      onChange={(event) => saveParagraph({ type: event.target.value })}
    >
      {filteredTypes.map((type, index) => (
        <MenuItem key={index} value={type}>
          {t(`paragraph.type.${type}`)}
        </MenuItem>
      ))}
    </Select>
  ) : (
    <Typography sx={{ color: 'text.primary', px: 1, ...(rest.sx ?? {}) }}>
      {paragraph.type ? t(`paragraph.type.${paragraph.type}`) : undefined}
    </Typography>
  )
}

export default ParagraphTypeSelect
